import { supabase } from './supabase';
import type { GeoDepartment, GeoMunicipality } from '@asi/shared';

// Guatemala country_id = 1
const GT_COUNTRY_ID = 1;

export async function fetchDepartments(countryId = GT_COUNTRY_ID): Promise<GeoDepartment[]> {
  const { data, error } = await supabase
    .from('geo_departments')
    .select('*')
    .eq('country_id', countryId)
    .order('name');
  if (error) throw error;
  return data as GeoDepartment[];
}

export async function fetchMunicipalities(departmentId: number): Promise<GeoMunicipality[]> {
  const { data, error } = await supabase
    .from('geo_municipalities')
    .select('*')
    .eq('department_id', departmentId)
    .order('name');
  if (error) throw error;
  return data as GeoMunicipality[];
}
